import React from 'react';

// Bei Bedarf können hier Bilder importiert werden, z.B. für Screenshots aus der Nextcloud-Oberfläche.
// Beispiel:
// import InterneFreigabeStandard from '../../assets/images/blog/Interne_Freigabe_Standard.png';

import {
  BlogContent,
  BlogHeading,
  BlogImage,
  BlogSection,
  BlogGallery,
} from '../../components/blog';

/**
 * Dieser Blogpost erläutert alle Möglichkeiten, in Nextcloud Dateien und Ordner zu teilen.
 * Er ersetzt den bisherigen Artikel zum Talk Desktop‑Client.
 */
const post = {
  id: 'nextcloud-dateien-ordner-teilen',
  slug: 'nextcloud-dateien-ordner-teilen',
  date: '2025-07-29T00:00:00.000Z',
  readTime: 8,
  categories: ['Nextcloud', 'Dateifreigabe', 'Zusammenarbeit'],
  thumbnail: "/images/blog/Nextcloud_Dateien_Teilen.png",
  thumbnailUrl: "https://pathconnect.eu/images/blog/Nextcloud_Dateien_Teilen.png",
  thumbnailSize: 'medium',
  showInPostHeader: true,

  searchableContent: 'Nextcloud Dateien Ordner teilen Freigaben öffentliche Links interne Freigabe Federated Shares Dateianfrage Talk File Drop Passwort Ablaufdatum Download-Limit',

  translations: {
    de: {
      title: 'Dateien und Ordner in Nextcloud teilen – alle Möglichkeiten im Überblick',
      formattedDate: '29. Juli 2025',
      excerpt:
        'Nextcloud ist eine leistungsstarke Open-Source-oftware und ermöglicht das sichere Teilen von Dateien und Ordnern. Wir zeigen dir alle Freigabearten und Funktionen im Überblick.',
      searchableContent:
        'Nextcloud Dateien Ordner teilen Freigaben öffentliche Links interne Freigabe Federated Shares Dateianfrage Talk File Drop Passwort Ablaufdatum Download-Limit',
      content: () => (
        <BlogContent>
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            Dateien und Ordner in Nextcloud teilen – alle Möglichkeiten im Überblick
          </h1>
          <p>
            Nextcloud ist eine leistungsstarke Open-Source-Software und ermöglicht unter anderem das sichere Teilen
            von Dateien und Ordnern mit anderen. Damit du den Überblick darüber behältst, wie du Inhalte mit
            Teammitgliedern, externen Partnern oder über mehrere Server hinweg freigeben kannst, stellen wir dir hier
            alle relevanten Freigabearten und -funktionen vor.
          </p>
          {/* Titelbild des Artikels */}
          <BlogImage
            src="/images/blog/Nextcloud_Dateien_Teilen.png"
            alt="Dateien und Ordner in Nextcloud teilen"
            size="medium"
            className="max-w-[420px] mx-auto"
            caption="Dateien und Ordner in Nextcloud teilen"
          />

          <BlogHeading>Interne Freigaben für Benutzer, Gruppen und Teams</BlogHeading>
          <p>
            Für die alltägliche Zusammenarbeit innerhalb deiner Organisation kannst du Ordner oder Dateien direkt mit
            einzelnen Nutzern, ganzen Gruppen oder Teams auf derselben Nextcloud-Instanz teilen. Dabei kannst du genau
            festlegen, welche Rechte die Empfänger erhalten, zum Beispiel Lesen, Schreiben, Löschen oder Weiterteilen.
          </p>
          <ol>
            <li>
              Klicke in der Dateien-App auf den Ordner oder die Datei, die du freigeben möchtest.
            </li>
            <li>
              Klicke rechts auf das Teilen-Symbol (Person mit Plus-Icon). Es erscheint die Seitenleiste »Teilen«.
            </li>
            <li>
              Gib im Feld unter »Interne Freigabe« den Namen der gewünschten Person, Gruppe oder des Teams ein. Du
              kannst auch eine Talk-Unterhaltung auswählen.
            </li>
            <li>
              In der ersten Ansicht kannst du zwischen den Berechtigungen »Nur anzeigen« und »Bearbeiten erlauben«
              wählen. Wenn du feingranulare Berechtigungen vergeben möchtest, klicke auf »Benutzerdefinierte
              Berechtigungen«.
            </li>
          </ol>
            <BlogGallery
            images={[
                { src: "/images/blog/Interne Freigabe Standard.png", alt: "Interne Freigabe Standard", className: "max-w-[360px] mx-auto" },
                { src: "/images/blog/Interne Freigabe Benutzerdefiniert.png", alt: "Interne Freigabe Benutzerdefiniert", className: "max-w-[360px] mx-auto" }
            ]}
            />
          <BlogHeading>Öffentliche Links– Inhalte mit Externen teilen</BlogHeading>
          <p>
            Wenn der Empfänger keinen Nextcloud-Account besitzt, kannst du Dateien und Ordner über öffentliche Links
            freigeben. Beim Erstellen eines solchen Links generiert Nextcloud einen zufälligen Token, der darin
            enthalten ist. Für Ordnerfreigaben stehen mehrere Optionen zur Verfügung:
          </p>
          <ul>
            <li>
              <strong>Schreibgeschützt:</strong> Die Empfänger können den Ordner einsehen und Dateien herunterladen.
            </li>
            <li>
              <strong>Hochladen und Bearbeiten:</strong> Erlaubt das Hochladen und Bearbeiten beziehungsweise Löschen
              vorhandener Dateien.
            </li>
            <li>
              <strong>File-Drop:</strong> Empfänger können Dateien hochladen, sehen aber nicht, was sich bereits im
              Ordner befindet.
            </li>
            <li>
              <strong>Download verbergen:</strong> Versteckt Download-Schaltflächen, um das Herunterladen zu
              erschweren.
            </li>
            <li>
              <strong>Passwortschutz und Ablaufdatum:</strong> Schütze deinen Link mit einem Passwort und lege ein
              Ablaufdatum fest.
            </li>
            <li>
              <strong>Notiz an Empfänger:</strong> Füge eine kurze Nachricht hinzu.
            </li>
            <li>
              <strong>Weitere Links:</strong> Erstelle mehrere Links mit unterschiedlichen Berechtigungen für denselben
              Ordner.
            </li>
            <li>
              <strong>Link-Name anpassen:</strong> Unter »Benutzerdefinierte Berechtigung« kannst du ein Freigabe Token
              einstellen. Dadurch wird der Freigabelink angepasst.
            </li>
          </ul>
          <BlogImage 
            src="/images/blog/Öffentliche Freigabe - Benutzerdefinierte Berechtitungen.png"
            alt="Öffentliche Freigabe - Benutzerdefinierte Berechtitungen"
            size="icon"
            className="max-w-[420px] mx-auto"
            caption="Öffentliche Freigabe - Benutzerdefinierte Berechtitungen"
            />
          <p><strong>So teilst du Inhalte per öffentlichem Link:</strong></p> <br></br>
          <ol>
            <li>
              Wähle den Ordner oder die Datei aus und klicke auf das Teilen-Symbol.
            </li>
            <li>
              Klicke im Abschnitt »Öffentlichen Link erstellen« auf das Plus-Symbol, um einen neuen Link zu erzeugen.
            </li>
            <li>
              Stelle die gewünschten Rechte ein (nur Lesen, Upload/Bearbeitung oder File-Drop) und aktiviere bei
              Bedarf Passwortschutz, Ablaufdatum oder Download-Limit.
            </li>
            <li>
              Der Link wird automatisch in die Zwischenablage kopiert. Du kannst ihn entweder an die gewünschte Person
              senden oder eine E-Mail-Adresse eingeben. Nextcloud versendet dann eine E-Mail mit dem Link.
            </li>
          </ol>
           <BlogGallery
            images={[
                { src: "/images/blog/Externe Freigabe Übersicht.png", alt: "Externe Freigabe Übersicht", className: "max-w-[360px] mx-auto" },
                { src: "/images/blog/Externe Freigabe - Öffentlicher Link.png", alt: "Externe Freigabe - Öffentlicher Link", className: "max-w-[360px] mx-auto" }
            ]}
            />
          <BlogHeading>Gastkonten</BlogHeading>
          <p>
            Neben reinen Link-Freigaben kannst du optional ein Gastkonto anlegen, sofern du die Guests-App installiert
            hast. Tippe dazu eine E-Mail-Adresse in das Freigabefeld und wähle die Option »Gast einladen«. Der Empfänger
            erhält daraufhin eine Einladung, ein Gastkonto zu erstellen. Gäste haben keine eigene Speicherquote,
            können aber Dateien in die geteilten Ordner hochladen. Administrator:innen können steuern, auf welche Apps
            Gäste Zugriff haben.
          </p>

          <BlogHeading>Dateianfragen– Dateien sammeln statt teilen</BlogHeading>
          <p>
            Mithilfe von Dateianfragen kannst du sicher Dateien von anderen sammeln, ohne ihnen Zugriff auf den Ordner
            zu gewähren.
          </p><br></br>
          <p><strong> Gehe dazu folgendermaßen vor:</strong></p><br></br>
          <ol>
            <li>
              Klicke in der Dateien-App auf »+« und dann auf »Dateianfrage erstellen«.
            </li>
            <li>
              Gib einen Titel und eine Beschreibung ein und wähle den Zielordner aus.
            </li>
            <li>
              Optional kannst du ein Ablaufdatum und ein Passwort setzen, um die Sicherheit zu erhöhen.
            </li>
            <li>
              Teile den generierten Link per E-Mail oder kopiere ihn in die Zwischenablage.
            </li>
          </ol>
          <p>
            Personen, die den Link aufrufen, müssen ihren Namen angeben. Dieser wird anschließend als Unterordner
            verwendet. Sie können Dateien hochladen, sehen jedoch keine bereits vorhandenen Dateien.
          </p>
         <BlogGallery
            images={[
                { src: "/images/blog/Dateianfrage erstellen.png", alt: "Dateianfrage erstellen", className: "max-w-[360px] mx-auto" },
                { src: "/images/blog/Externe Freigabe - Öffentlicher Link.png", alt: "Externe Freigabe - Öffentlicher Link", className: "max-w-[360px] mx-auto" },
                { src: "/images/blog/Dateianfrage Passwortschutz und Ablaufdatum.png", alt: "EDateianfrage Passwortschutz und Ablaufdatum", className: "max-w-[360px] mx-auto" } 
              ]}
            />
          <BlogHeading>Federated Shares– mit anderen Nextcloud-Servern teilen</BlogHeading>
          <p>
            Wenn der Empfänger einen Account auf einem anderen Nextcloud-Server hat, kannst du über federierte
            Freigaben Dateien mit ihm teilen. Dazu benötigst du die sogenannte Federated-Cloud-ID in der Form
            »benutzername@server-url«.
          </p>
          <ol>
            <li>
              Öffne die Dateien-App und klicke auf das Teilen-Symbol neben der Datei oder dem Ordner.
            </li>
            <li>
              Gib im Freigabefeld die Federated-Cloud-ID des Empfängers ein (z.B. demo@cloud.example.com).
            </li>
            <li>
              Der Empfänger erhält in seiner Nextcloud eine Benachrichtigung und kann die Freigabe annehmen oder
              ablehnen.
            </li>
          </ol>
          <p>
            Federated Shares eignen sich, wenn du dauerhaft mit Personen auf anderen Instanzen zusammenarbeiten
            möchtest. Du kannst auch öffentliche Link-Freigaben in deine Nextcloud importieren, indem du die
            Federated-Cloud-ID der Freigabe im Freigabedialog angibst.
          </p>
          <BlogImage 
            src="/images/blog/Federated Share.png"
            alt="Federated Share"
            size="icon"
            className="max-w-[420px] mx-auto"
            caption="Federated Share"
            />
          <BlogHeading>Teilen in Nextcloud Talk</BlogHeading>
          <p>
            Mit Nextcloud Talk kannst du Chats und Videokonferenzen mit den Dateien in deiner Cloud verbinden. In
            Chat Räumen lassen sich Dateien und Ordner direkt per Dra-and-Drop oder über die Share-Seitenleiste
            hinzufügen. Die Dateien sind anschließend für alle Teilnehmenden sichtbar und – bei Office-Dokumenten –
            können sie sogar direkt gemeinsam bearbeitet werden. Gäste, die am Talk-Chat teilnehmen, erhalten über
            einen öffentlichen Link Zugriff.
          </p>
          <ol>
            <li>
              Öffne eine vorhandene Talk-Unterhaltung oder erstelle einen neuen Raum.
            </li>
            <li>
              Ziehe die Datei per Drag-and-Drop in das Chatfenster oder klicke links unten auf das Plus-Zeichen.
            </li>
            <li>
              Alle Teilnehmer können die Datei sehen, Kommentare hinterlassen und – falls es sich um ein
              Office‑Dokument handelt – dieses direkt im Browser gemeinsam bearbeiten.
            </li>
          </ol>
          <p>
            Dank der Integration kannst du im Chat nicht nur Nachrichten senden und empfangen, sondern auch Videoanrufe
            starten. Außerdem wirst du benachrichtigt, wenn neue Dateien in einem Ordner hochgeladen werden.
          </p>
          <BlogImage 
            src="/images/blog/Nextcloud Dateien teilen.png"
            alt="Nextcloud TalkDateien teilen"
            size="icon"
            className="max-w-[420px] mx-auto"
            caption="Nextcloud TalkDateien teilen"
            />
          <BlogHeading>Fazit</BlogHeading>
          <p>
            Mit Nextcloud kannst du Dateien und Ordner bedarfsgerecht teilen – ob innerhalb deines Teams, per Link
            oder serverübergreifend. Dank granular einstellbarer Berechtigungen, Passwortschutz, Ablaufdaten sowie
            Funktionen wie Dateianfragen oder Talk-Integration behältst du stets die Kontrolle über deine Daten.
            Durch die richtige Auswahl der Freigabeart und die Berücksichtigung der Sicherheitseinstellungen kannst
            du deine Zusammenarbeit effizient und datenschutzfreundlich gestalten.
          </p>

          <BlogSection title="Nextcloud bei PathConnect">
            <p>All diese Funktionen sind selbstverständlich in unserem Nextcloud-Angebot bei PathConnect enthalten.</p>
            <p>Wir kümmern uns um die Installation, individuelle Einrichtung und Wartung – damit du dich ganz auf deine Arbeit konzentrieren kannst.</p>
            <p>Mit PathConnect profitierst du von persönlichem Support, maßgeschneiderten Lösungen und vollem Datenschutz – egal, ob du Nextcloud für dein Team, dein Unternehmen oder für die Zusammenarbeit mit Kunden einsetzen möchtest.</p>
            <b>Du möchtest die Nextcloud Teilen Funktion für dein Team nutzen? Sprich uns an – wir beraten dich gerne!</b>
          </BlogSection>

        </BlogContent>
      )
    }
  },

  get title() {
    return this.translations.de.title;
  },
  get formattedDate() {
    return this.translations.de.formattedDate;
  },
  get excerpt() {
    return this.translations.de.excerpt;
  },
  get content() {
    return this.translations.de.content;
  }
};

export default post;